import { Prisma } from "@prisma/client";

export const eventStructureArgs = Prisma.validator<Prisma.EventStructureDefaultArgs>()({
  select: {
    id: true,
    eventId: true,
    structureId: true,
    hasTicketAlertThreshold: true,
    ticketAlertThreshold: true,
    stand: true,
    hall: true,
  },
});

export type EventStructure = Prisma.EventStructureGetPayload<typeof eventStructureArgs>;
